
//DEV ENV
export const local = {
  api: {
    url: process.env.REACT_APP_API_URL,
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

export const development = {
  api: {
    url: process.env.REACT_APP_API_URL,
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

//STAGE ENV 
export const staging = {
  api: {
    url: 'https://stagapi.nmtsecurity.com/nmt/api/v1/',
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

//PRODUCTION ENV
export const prod = {
  api: {
    url: 'https://prodapi.nmtsecurity.com/nmt/api/v1/',
    AUTH: process.env.REACT_APP_API_KEY,
  },
};

//UK ENV
export const uk = {
  api: {
    url: 'https://ukprodapi.nmtsecurity.com/nmt/api/v1/',
    AUTH: process.env.REACT_APP_API_KEY
  },
};
